var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgreement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3335 3.16663H6.66683C5.93045 3.16663 5.3335 3.76358 5.3335 4.49996V28.5C5.3335 29.2363 5.93045 29.8333 6.66683 29.8333H25.3335C26.0699 29.8333 26.6668 29.2363 26.6668 28.5V4.49996C26.6668 3.76358 26.0699 3.16663 25.3335 3.16663Z",
    stroke: "#192BC2",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 3.16663H16.667V13.8333L13.667 11.1666L10.667 13.8333V3.16663Z",
    stroke: "#192BC2",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 19.1666H17.3337M10.667 23.1666H21.3337",
    stroke: "#192BC2",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreement);
export default __webpack_public_path__ + "static/media/Agreement.47588a432253fd9ea736dab3605e6989.svg";
export { ForwardRef as ReactComponent };